import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export const roundValue = (value: WpsRuntime.atv.wps.Double, factor: number) =>
  (Math.round(value * factor) / factor) // case factor=2: round 4.41 => 4.5; case factor=10: round 4.41 => 4.4q